import { Component, OnInit } from '@angular/core';
import {ScheduleService} from '../../../_services/_registration/schedule.service';

@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.css']
})
export class SchedulerComponent implements OnInit {

  constructor(private scheduleService: ScheduleService) { }

  availabilities: string[];
  selectedTimeslot: string;
  isLoading = true;

  ngOnInit(): void {
    this.scheduleService.getAvailabilities('2020-06-25T15:00:00+0200').subscribe(response => {
      this.availabilities = response.map(entry => {
        const date = new Date(entry.time);
        return (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            + (date.getMinutes() === 0 ? '00' : date.getMinutes());
      });
      console.log(this.availabilities);
      this.isLoading = false;
    });
  }

  selectTimeslot(timeslot: string) {
    this.selectedTimeslot = timeslot;
  }

  bookSelectedTimeslot() {
    this.scheduleService.checkAvailabilitie('2020-06-25T' + this.selectedTimeslot + ':00+0200', 4055914)
      .subscribe(response => {
        console.log(response);
        if (response.valid === true) {
          this.scheduleService.bookTimeslot('2020-06-25T' + this.selectedTimeslot + ':00+0200',
              'Lennart', 'Paul', 'lenni.paul@gmx.de', 4055914)
            .subscribe(res => {
              console.log(res);
            });
        }
      });
  }

}
